<template>
    <div class="col-12">
        <div class="shop_item shop_item-show_more btn"
             @click="goToShopCategory(item)">
            {{item.text}}
        </div>
    </div>
</template>

<script>

    export default {
        name: "ShopShowmore",
        props: {
            item: {},
            categoryName: String
        },
        computed: {

        },
        methods: {
          goToShopCategory(item) {
            const scheduleId = this.$route.params.scheduleId;

            if (scheduleId) {
              this.$router.push({
                name: 'ShopScheduleCategory',
                params: {
                  categoryId: item.id,
                  scheduleId: scheduleId,
                },
                query: {
                  categoryName: this.categoryName
                }
              })
            } else {
              this.$router.push({
                name: 'ShopCategory',
                params: {
                  categoryId: item.id,
                },
                query: {
                  categoryName: this.categoryName
                }
              })
            }
          },
        },
    }
</script>